import { styled, TableCell, TableHead, Typography } from "@mui/material";
import { tableCellClasses } from "@mui/material";
import React from "react";

function TableStyleUtility(props) {
  const compBids = parseInt(props.transactions.compBids, 10);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  return (
    <>
      <Typography component="caption" variant="visuallyHidden">
        Simple Table
      </Typography>
      <TableHead>
        <StyledTableCell></StyledTableCell>
        <StyledTableCell align="left">{props.texts.JD_DEALER}</StyledTableCell>
        {Array(compBids)
          .fill(null)
          .map((value, index) => (
            <StyledTableCell key={index}>
                {props.texts.COMPETITOR} #{[index + 1]}
            </StyledTableCell>
          ))}
      </TableHead>
    </>
  );
}

export default TableStyleUtility;
